<template>
  <client-only>
    <Modal
      v-bind="modalProps"
      width="470"
      @closed="onModalClose"
    >
      <div class="close" @click="toggleActivation(false)">
        <OSvg svg="menu-open" />
      </div>
      <div>
        <h3 class="ota-h3 mb-rem" v-text="title" />
        <p class="ota-p16" v-text="body" />
        <form class="pt-5" @submit.prevent="submit">
          <OInput
            id="email"
            v-model="$v.email.$model"
            name="email"
            type="text"
            required
            :label="$t('Loyalty.Webshop.ProductDetail.EmailAddress')"
            :input-classes="['w-full']"
            :error="errorMessage"
          />
          <div class="flex pt-5">
            <OButton type="submit" class="flex-1" variant="secondary">
              {{ buttonText }}
            </OButton>
          </div>
        </form>
      </div>
    </Modal>
  </client-only>
</template>

<script>
import OInput from '@/components/OInput'
import OButton from '@/components/OButton'
import modalMixin from '@/mixins/modal'
import { notifyMeModalTypes } from '@/enums/webshop'
import { email, required } from 'vuelidate/lib/validators'

export default {
  name: 'NotifyMeModal',
  components: { OInput, OButton },
  mixins: [modalMixin({ modalName: 'notify-me-modal' })],
  props: {
    type: {
      type: String,
      default: notifyMeModalTypes.comingSoon,
      validator: value => [notifyMeModalTypes.comingSoon, notifyMeModalTypes.soldOut].includes(value)
    }
  },
  validations () {
    const validations = {
      email: {
        required,
        email
      }
    }

    return validations
  },
  data () {
    return {
      email: '',
      invalidForm: false
    }
  },
  computed: {
    title () {
      if (this.type === notifyMeModalTypes.comingSoon) {
        return this.$t('Loyalty.Webshop.ProductDetail.ComingSoon')
      }

      if (this.type === notifyMeModalTypes.soldOut) {
        return this.$t('Loyalty.Webshop.ProductDetail.SoldOut')
      }

      return ''
    },
    body () {
      if (this.type === notifyMeModalTypes.comingSoon) {
        return this.$t('Loyalty.Webshop.ProductDetail.ComingSoonAlert')
      }

      if (this.type === notifyMeModalTypes.soldOut) {
        return this.$t('Loyalty.Webshop.ProductDetail.StockAlert')
      }

      return ''
    },
    buttonText () {
      return this.$t('Loyalty.Webshop.ProductDetail.NotifyMe')
    },
    errorMessage () {
      if (this.invalidForm) {
        if (!this.$v.email.required) {
          return this.$t('Form.Error.Required')
        }

        if (!this.$v.email.email) {
          return this.$t('Form.Error.EmailIncorrect')
        }
      }

      return ''
    }
  },
  methods: {
    submit () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.invalidForm = true

        return
      }

      this.$emit('submit', { email: this.email, type: this.type })
    }
  }
}
</script>

<style lang="postcss" scoped>
>>> .vm--overlay {
  background: rgba(0, 0, 0, 0.3);
}

>>> .notify-me-modal {
  @apply shadow-none bg-white overflow-y-scroll px-9 py-10 rounded-lg !important;

  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* IE 10+ */

  &::-webkit-scrollbar {
    display: none; /* Chrome/Safari/Webkit */
  }
}

.close {
  @apply absolute text-5xl font-semibold cursor-pointer mt-5 mr-8 z-10 top-0 right-0;

  svg {
    @apply fill-gray-400 text-gray-400 !important;
  }
}

@screen lg {
  >>> .notify-me-modal {
    top: 5rem !important;
  }
}
</style>
